import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Chip,
  IconButton,
  Button,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";

export function ViewAllTagsModal({
  open,
  onClose,
  tags,
  typeMap,
  onRemoveTag,
  onClearAll,
  title,
}) {
  const grouped = {};
  tags.forEach((tag) => {
    const type = typeMap?.[tag.type] || tag.type || "Other";
    if (!grouped[type]) grouped[type] = [];
    grouped[type].push(tag);
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{ fontWeight: 700, display: "flex", alignItems: "center" }}
      >
        {title}
        <IconButton onClick={onClose} sx={{ marginLeft: "auto" }} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {Object.entries(grouped).map(([group, list]) => (
          <Box key={group} sx={{ mb: 3 }}>
            {tags.some((t) => t.type) && (
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                {group}
              </Typography>
            )}
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {list.map((tag) => (
                <Chip
                  key={tag.id}
                  label={tag.name}
                  color="secondary"
                  variant="outlined"
                  onDelete={() => onRemoveTag(tag)}
                  deleteIcon={<DeleteIcon />}
                  sx={{ fontSize: 15, height: 32 }}
                />
              ))}
            </Stack>
            <Divider sx={{ mt: 2 }} />
          </Box>
        ))}
        {tags.length === 0 && (
          <Typography color="text.secondary">No tags selected.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClearAll}
          color="error"
          variant="outlined"
          startIcon={<DeleteIcon />}
        >
          Clear All
        </Button>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
